export const API_ENDPOINTS = {
  AUTH_STATUS: '/api/auth/status',
  CATEGORIES: '/api/categories',
  CATEGORIES_CREATE: '/api/categories/create',
  CATEGORIES_UPDATE: '/api/categories/update',
  CATEGORIES_DELETE: '/api/categories/delete',
  PROJECTS: '/api/projects',
  PROJECT_DETAIL: '/api/project-detail',
  CONTACT: '/api/contact',
  LOGIN: '/api/auth/login',
  FEATURED_PROJECTS: '/api/featured-projects',
};

export const TOAST_LIMIT = 3;
export const TOAST_REMOVE_DELAY = 5000;
